import React from 'react';
import loadingGif from '../../images/gif/loading_screen/tf_default_loading.gif';

export const LoadingScreen: React.FC = () => (
  <div className="flex justify-center items-center">
    <img src={loadingGif} alt="Loading..." className="w-1/3" />
  </div>
);

export default LoadingScreen;